import { Formik } from 'formik';
import React, { useState } from 'react';
import Api from '@Api/index';
import createStepper, { useStepper } from '@Components/Stepper';
import UserRegister, {
	UserRegisterResponse,
} from '@Configs/schemas/UserRegister';
import RegisterSendView from '../../components/RegisterSendView';
import RegistrationViewStep1 from '../../components/RegisterStep1';
import RegistrationViewStep2 from '../../components/RegisterStep2';
import TopBarRegister from '../../components/TopBarRegister';
import { registrationSchemaRegister } from './validation';

type RegisterContainerProps = {
	children: React.ReactNode;
};
export const initialValues = {
	firstname: '',
	lastname: '',
	email: '',
	phone_number: '',
	national_identification: '',
	levelTeacher: '',
	password: '',
	confirmpassword: '',
	acceptTerms: false,
};

type RegisterContainerStateType = {
	firstname: string;
	lastname: string;
	email: string;
	phone_number: string;
	national_identification: string;
	levelTeacher: string;
	password: string;
	acceptTerms: boolean;
};

const RegisterStepper = createStepper();

const RegisterContainer = ({ children }: RegisterContainerProps) => {
	const [requestResults, setRequestResults] =
		useState<UserRegisterResponse | null>(null);
	const handleSubmit = async ({
		firstname,
		lastname,
		email,
		phone_number,
		national_identification,
		levelTeacher,
		password,
		acceptTerms,
	}: RegisterContainerStateType) => {
		const data: UserRegister = {
			first_name: firstname,
			last_name: lastname,
			email,
			phone_number,
			national_identification,
			levelTeacher,
			password,
			acceptTerms,
		};
		try {
			console.log(data, 'data');
			const res = await Api.Users.registerUser(data);

			setRequestResults(res);
		} catch (error) {
			setRequestResults({
				status: 'error',
			});
		}
	};

	return requestResults === null ? (
		<Formik
			initialValues={initialValues}
			validationSchema={registrationSchemaRegister}
			onSubmit={handleSubmit}
		>
			<RegisterStepper topBar={<TopBarRegister />}>
				<RegisterStepper.Step label="1" component={RegistrationViewStep1} />

				<RegisterStepper.Step label="2" component={RegistrationViewStep2} />
			</RegisterStepper>
		</Formik>
	) : (
		<RegisterSendView requestResults={requestResults} />
	);
};

export default RegisterContainer;
